import { SpacingOptions } from '@mui/system';

export const spacing: SpacingOptions = 4;
